/**
 * ATTENZIONE, questa lista potrebbe non essere allineata con il BK
 */
export enum AppAssessmentsField {
  status = 'status',
  statusLabel = 'statusLabel',
  builtIn = 'builtIn',
  completed = 'completed',
  createdAt = 'createdAt',
  creatorUserId = 'creatorUserId',
  deleted = 'deleted',
  description = 'description',
  id = 'id',
  internalId = 'internalId',
  lastUpdateUserId = 'lastUpdateUserId',
  legalEntityId = 'legalEntityId',
  lockedAt = 'lockedAt',
  lockedBy = 'lockedBy',
  name = 'name',
  organizationId = 'organizationId',
  parentId = 'parentId',
  surveyId = 'surveyId',
  type = 'type',
  updatedAt = 'updatedAt',
  validated = 'validated',
  version = 'version',
  scenarioRLabel = 'scenarioRLabel',
  scenarioILabel = 'scenarioILabel',
  scenarioDLabel = 'scenarioDLabel',
}
